import { useEffect, useLayoutEffect, useState } from "react";
import Table from "../../components/admin/Table";
import { studentsData } from "../../assets/studentsData";
import { useNavigate } from "react-router-dom";

export default function AddNewAssesment() {
  const [allStudents, setAllStudents] = useState([]);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  useLayoutEffect(() => {
    if (user.role !== "ADMIN") {
      localStorage.removeItem("user");
      navigate("/login");
      return;
    }
  }, []);
  useEffect(() => {
    setAllStudents(studentsData);
  }, []);
  return (
    <>
      <div className="pb-10">
        <Table
          tableTitle={"Add New Assesmen"}
          data={allStudents}
          setData={setAllStudents}
          columns={[
            "Student Name",
            "Student ID",
            "Marks",
            "Total Marks",
            "Percentage",
            "Action",
          ]}
          forNewAssesment={true}
        />
      </div>
    </>
  );
}
